<script lang="ts">
	import * as Accordion from '$lib/components/ui/accordion/index.js';
	import type { MarketplaceFaqItem } from '$lib/content/marketplace-seo';
	import * as m from '$lib/paraglide/messages.js';
	import { getLocale } from '@/paraglide/runtime';
	import BoatLicenseTable from './BoatLicenseTable.svelte';

	interface Props {
		title: string;
		faqs: MarketplaceFaqItem[];
	}

	let { title, faqs }: Props = $props();

	const locale = $derived(getLocale());
	const licenseIntro = $derived.by(() => {
		void locale;
		return m.marketplace_seo_spain_faq_a7_intro();
	});
</script>

<section aria-labelledby="marketplace-faq-heading" class="space-y-4">
	<h2 id="marketplace-faq-heading" class="text-xl font-semibold tracking-tight md:text-2xl">
		{title}
	</h2>

	<Accordion.Root type="single" class="w-full">
		{#each faqs as faq, index (faq.question)}
			<Accordion.Item value={`faq-${index}`}>
				<Accordion.Trigger class="text-left text-sm md:text-base">{faq.question}</Accordion.Trigger>
				<Accordion.Content class="text-muted-foreground text-sm leading-relaxed md:text-base">
					{#if faq.answerVariant === 'license-table'}
						<div class="space-y-4">
							<p>{licenseIntro}</p>
							<BoatLicenseTable />
						</div>
					{:else}
						{faq.answer}
					{/if}
				</Accordion.Content>
			</Accordion.Item>
		{/each}
	</Accordion.Root>
</section>
